import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import mainImg from "../images/main.png"
import main3Img from "../images/main3.png"
import main4Img from "../images/main4.png"
import main5Img from "../images/main5.png"
import main6Img from "../images/main6.png"
// import allFruits from "../images/all.png"
import logo from "../images/logo.png"
import { BrowserView, MobileView } from 'react-device-detect';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'
import axios from 'axios';
const clientAxios = axios.create({
  baseURL: 'https://api.orchata.com',
});
const IndexPage = () => {

  const [show, setShow] = React.useState(false);
  const [showThanks, setShowThanks] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState('')

  const sendWhatsapp = async () => {
    await clientAxios.post(
      '/whatsapp/send',
      {
        whatsapp: phoneNumber,
      },
      { headers: { 'Content-Type': 'application/json' } }
    );
    setShow(false);
    setShowThanks(true);
    setTimeout(() => {
      setPhoneNumber('');
    }, 1000);
  };

  return (
    <Layout>
      <Seo title="orchata" />
      <div>
        <meta name="facebook-domain-verification" content="ood060f4or3m6ru8xa6ue5e506u6zy" />
        <nav className="fixed z-50 w-screen grid lg:grid-flow-col lg:grid-cols-2 bg-pink">
          <div className="lg:space-y-20 w-9/12 m-auto py-4">
            <img className="hidden lg:block h-9 w-auto my-auto" src={logo} alt="orchata logo" />
            <img className="lg:hidden h-10 w-auto my-auto" src={logo} alt="orchata logo" />
          </div>
          <div className="lg:space-y-20 w-9/12 m-auto py-4 text-right">
            <a href="https://orchata.com/terms/" className="font-sans text-white font-normal w-auto my-auto mr-3">Terminos y condiciones</a>
            <a href="https://orchata.com/terms/" className="font-sans text-white font-normal w-auto my-auto mr-3">Aviso de privacidad</a>
            <a href="https://ahtq8e54va7.typeform.com/to/thTJr6Ow" className="font-sans text-white font-normal w-auto my-auto">Contacto</a>
          </div>
        </nav>
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-screen bg-pink">
          <div className="lg:space-y-20 w-9/12 m-auto">
            <div className="space-y-10">
              <div className="lg:hidden mt-4"></div>
              <h1 className="font-sans text-white text-4xl lg:text-6xl">Pide tu súper entregamos en 15 minutos</h1>
              <p className="text-white">Te llevamos miles de productos a la puerta de tu casa. ¡sin filas! .</p>
              <div>
                <MobileView>
                  <a href="https://orchata.com/descargar" className="btn-primary text-pink font-semibold px-5 py-3">Descargar App</a>
                </MobileView>
                <BrowserView>
                  <button 
                    onClick={() => setShow(true)}
                    className="btn-primary text-pink font-semibold px-5 py-3">
                      Descargar App
                  </button>
                </BrowserView>
              </div>
            </div>
          </div>
          <div className="lg:h-screen flex items-center">
            <img className="mx-auto w-8/12" src={mainImg} alt="screen products"/>
            {/* <a href="https://lapieza.io/orchata" target="_blank" rel="noreferrer" className="fixed bottom-0 right-0 mb-3 mr-3 font-semibold">Únete al equipo</a> */}
          </div>
        </div>
        {/* <div className="font-sans grid lg:grid-flow-col lg:grid-cols-1 h-screen bg-white bg-auto bg-cover" style={{backgroundImage: `url(${allFruits})`}}> */}
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-1 h-screen bg-white">
          <div className="lg:space-y-20 relative w-9/12 m-auto flex grid justify-items-center">
            <h1 className="font-sans text-pink text-center text-4xl lg:text-6xl">Somos el delivery más rápido de México <br/>en 15 minutos.</h1>
            <p className="text-gray-paragraph">Te llevamos tu súper en 15 minutos, ¡sin sustitutos!</p>
            <MobileView>
              <a href="https://orchata.com/descargar" className="btn-pink text-white font-semibold px-5 py-3 mx-auto">Descarga la app</a>
            </MobileView>
            <BrowserView>
              <button 
                onClick={() => setShow(true)}
                className="btn-pink text-white font-semibold px-5 py-3 mx-auto">
                  Descarga la app
              </button>
            </BrowserView>
          </div>
        </div>
        <hr className="bg-pink opacity-30" />
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-screen bg-white">
          <div className="lg:space-y-20 w-9/12 m-auto">
            <div className="space-y-10">
              <h1 className="font-sans text-pink text-4xl lg:text-6xl">Pide en segundos, <br/> recibe en minutos</h1>
              <p className="text-gray-paragraph">Tu super en un solo lugar, sin salir de casa.</p>
              <div>
                <MobileView>
                  <a href="https://orchata.com/descargar" className="btn-pink text-white font-semibold px-5 py-3">Pedir ahora</a>
                </MobileView>
                <BrowserView>
                  <button 
                    onClick={() => setShow(true)}
                    className="btn-pink text-white font-semibold px-5 py-3">
                      Pedir ahora
                  </button>
                </BrowserView>
              </div>
            </div>
          </div>
          <div className="lg:h-screen flex items-center">
            <img className="mx-auto w-8/12" src={main3Img} alt="screen products"/>
            {/* <a href="https://lapieza.io/orchata" target="_blank" rel="noreferrer" className="fixed bottom-0 right-0 mb-3 mr-3 font-semibold">Únete al equipo</a> */}
          </div>
        </div>
        <hr className="bg-pink opacity-30" />
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-screen bg-white">
          <div className="lg:h-screen flex items-center">
            <div className="space-y-10 relative">
              <img className="mx-auto w-8/12" src={main4Img} alt="screen products"/>
            </div>
          </div>
          <div className="lg:space-y-20 w-9/12 m-auto">
            <div className="space-y-10">
              <h1 className="font-sans text-pink text-4xl lg:text-6xl">Ya estamos en <br/> Monterrey y Guadalajara.</h1>
              <p className="text-gray-pragraph">Te llevamos miles de productos a la puerta de tu casa. ¡sin filas! .</p>
              <div>
                <MobileView>
                  <a href="https://orchata.com/descargar" className="btn-pink text-white font-semibold px-5 py-3">Ver cobertura</a>
                </MobileView>
                <BrowserView>
                  <button 
                    onClick={() => setShow(true)}
                    className="btn-pink text-white font-semibold px-5 py-3">
                      Ver cobertura
                  </button>
                </BrowserView>
              </div>
            </div>
          </div>
        </div>
        <hr className="bg-pink opacity-30" />
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-screen bg-white">
          <div className="lg:space-y-20 w-9/12 m-auto">
            <img className="hidden lg:block h-9 w-auto" src={logo} alt="orchata logo" />
            <img className="lg:hidden h-10 w-auto" src={logo} alt="orchata logo" />
            <div className="space-y-10">
              <h1 className="font-sans text-pink text-4xl lg:text-5xl">Nuestro equipo trabaja <br/> para darte lo mejor.</h1>
              <p className="text-white">Te llevamos miles de productos a la puerta de tu casa. ¡sin filas! .</p>
              <div>
                <MobileView>
                  <a href="https://orchata.com/descargar" className="btn-pink text-white font-semibold px-5 py-3">Descarga orchata</a>
                </MobileView>
                <BrowserView>
                  <button 
                    onClick={() => setShow(true)}
                    className="btn-pink text-white font-semibold px-5 py-3">
                      Descarga orchata
                  </button>
                </BrowserView>
              </div>
            </div>
          </div>
          <div className="lg:h-screen flex items-center">
            <img className="mx-auto w-8/12" src={main5Img} alt="screen products"/>
            {/* <a href="https://lapieza.io/orchata" target="_blank" rel="noreferrer" className="fixed bottom-0 right-0 mb-3 mr-3 font-semibold">Únete al equipo</a> */}
          </div>
        </div>
        <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-3/6 bg-pink">
          <div className="lg:space-y-20 w-9/12 m-auto">
            <div className="space-y-10">
              <div className="lg:hidden mt-4"></div>
              <h1 className="font-sans text-white text-4xl lg:text-6xl">Te regalamos $100 <br />en tu primer pedido</h1>
              <p className="text-white">En compras mayores a $500 pesos</p>
              <div>
                <MobileView>
                  <a href="https://orchata.com/descargar" className="btn-primary text-pink font-semibold px-5 py-3">Pedir</a>
                </MobileView>
                <BrowserView>
                  <button 
                    onClick={() => setShow(true)}
                    className="btn-primary text-pink font-semibold px-5 py-3">
                      Pedir
                  </button>
                </BrowserView>
              </div>
            </div>
          </div>
          <div className="lg:h-screen flex items-center">
            <img className="mx-auto w-8/12" src={main6Img} alt="screen products"/>
            {/* <a href="https://lapieza.io/orchata" target="_blank" rel="noreferrer" className="fixed bottom-0 right-0 mb-3 mr-3 font-semibold">Únete al equipo</a> */}
          </div>
        </div>
        <footer className="fixed bottom-0 w-screen flex items-center justify-between flex-wrap bg-teal-500 py-6">
          <div className="lg:space-y-20 w-11/12 m-auto">
            <div className="flex items-center flex-shrink-0 text-white mr-6">
            </div>
          </div>
          <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
            <div>
              <a href="https://orchata.com/descargar">
                {/* <img className="inline-block text-sm px-4 py-2 leading-none h-32 w-auto fixed right-3 bottom-0" src={downloadImg} alt="orchata logo" /> */}
              </a>
            </div>
          </div>
        </footer>
      </div>
      <div className="modal font-sans" style={{ display: show ? 'block' : 'none'}}>
        <div className="overlay"></div>
        <div className="modal_content">
          <h2>Hey ¡Hola!</h2>
          <p>
            Dejame mandarte un whatsapp para que descargues nuestra app :D 
          </p>
          <PhoneInput
            country="MX"
            className="py-2 border border-fuchsia-600 w-full mb-10 px-2"
            placeholder="Tu whatsapp"
            flags={flags}
            rules={{ required: true }}
            value={phoneNumber}
            onChange={setPhoneNumber}/>
          <button 
            onClick={() => setShow(false)}
            title="Close" 
            className="close_modal mr-3">
            x
          </button>
          <button 
            onClick={() => { sendWhatsapp(); }}
            title="Close" 
            className="btn-pink send py-2 mr-3">
            Enviar
          </button>
        </div>
      </div>
      <div className="modal font-sans" style={{ display: showThanks ? 'block' : 'none'}}>
        <div className="overlay"></div>
        <div className="modal_content">
          <h2>Muchas gracias</h2>
          <p>
            En breve recibiras un whatsapp con el link de descarga.
          </p>
          <button 
            onClick={() => setShowThanks(false)}
            title="Close" 
            className="close_modal mr-3">
            x
          </button>
        </div>
      </div>
    </Layout>
)}

export default IndexPage
